/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TeamLegalEntityAddress
 */
export interface TeamLegalEntityAddress {
    /**
     * 
     * @type {string}
     * @memberof TeamLegalEntityAddress
     */
    formattedAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamLegalEntityAddress
     */
    countryCode?: string;
}

/**
 * Check if a given object implements the TeamLegalEntityAddress interface.
 */
export function instanceOfTeamLegalEntityAddress(value: object): value is TeamLegalEntityAddress {
    return true;
}

export function TeamLegalEntityAddressFromJSON(json: any): TeamLegalEntityAddress {
    return TeamLegalEntityAddressFromJSONTyped(json, false);
}

export function TeamLegalEntityAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamLegalEntityAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'formattedAddress': json['formattedAddress'] == null ? undefined : json['formattedAddress'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
    };
}

export function TeamLegalEntityAddressToJSON(value?: TeamLegalEntityAddress | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'formattedAddress': value['formattedAddress'],
        'countryCode': value['countryCode'],
    };
}

